type HumanizeListIteree = string | number | boolean;

export type HumanizeListParams<T extends HumanizeListIteree> = {
  readonly formatter?: (value: T) => string;
  readonly conjunction?: "and" | "or" | null;
  readonly oxfordComma?: boolean;
};

export const humanizeList = <T extends HumanizeListIteree>(
  values: T[],
  {
    formatter = (value: T) => String(value),
    conjunction = null,
    oxfordComma = true,
  }: HumanizeListParams<T>,
): string => {
  if (values.length === 0) {
    return "";
  } else if (values.length === 1) {
    return formatter(values[0]);
  }
  if (conjunction) {
    let initials = values
      .slice(0, values.length - 1)
      .map((v) => formatter(v))
      .join(", ");
    if (values.length >= 3 && oxfordComma === true) {
      initials = initials + ",";
    }
    return [initials, conjunction, formatter(values[values.length - 1])].join(
      " ",
    );
  }
  return values.map((v) => formatter(v)).join(" ");
};
